import * as categories from '../categories';
import { STRICTLY_NECESSARY, TARGETING, PERFORMANCE, SOCIAL } from '../constants';

const dict = {
	cookies: STRICTLY_NECESSARY,
	ad_delivery: TARGETING,
	advertising_personalization: TARGETING,
	content_personalization: TARGETING,
	cookies_marketing: TARGETING,
	create_ads_profile: TARGETING,
	create_content_profile: TARGETING,
	device_access: TARGETING,
	improve_products: TARGETING,
	link_devices: TARGETING,
	market_research: TARGETING,
	measure_ad_performance: TARGETING,
	offline_match: TARGETING,
	precise_geo: TARGETING,
	select_basic_ads: TARGETING,
	select_personalized_ads: TARGETING,
	select_personalized_content: TARGETING,
	measure_content_performance: PERFORMANCE,
	analytics: PERFORMANCE,
	cookies_analytics: PERFORMANCE,
	cookies_social: SOCIAL
};

export const set = (ids) => {
	const newCats = (Array.isArray(ids) ? ids : ids.split(',')).map(id => dict[id]).filter(a => !!a);
	categories.set(newCats);
};
